import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { MstConsultantModel }  from 'app/model/mst.consultant.model';

import { mstInterface } from 'api-interface/mst.interface';
import { MstHarassmentTypeModel } from 'app/model/mst.harassmentType.model';
import { MstInjuryTimeModel } from 'app/model/mst.injuryTime.model';
import { MstSystemAdminModel } from 'app/model/mst.systemAdmin.model';

// import * as CryptoJS from 'crypto-js';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';
import { HttpService } from 'app/services/base/http.service';
import { MstNotificationModel } from 'app/model/mst.notification.model';

@Injectable()
export class MasterService extends HttpService {

    /**
     * 相談窓口担当者
     * キャッシュ用
     */
    private consultants: MstConsultantModel[];

    /**
     * 相談区分
     * キャッシュ用
     */
    private harassmentTypes: MstHarassmentTypeModel[];

    /**
     * 被害時間帯
     * キャッシュ用
     */
    private injuryTimes: MstInjuryTimeModel[];


    /**
     * お知らせ
     * キャッシュ用
     */
    private notifications: MstNotificationModel[];


    constructor(private injector: Injector) {
        super(injector);
    }

    /**
     * 相談窓口の相談担当者一覧取得
     */
    public async getConsultants(): Promise<Array<MstConsultantModel>> {

        if (!this.consultants) {
            this.consultants = await this.get<Array<mstInterface.consultant.GetRes>>('/mst/consultant');
        }

        return JSON.parse(JSON.stringify(this.consultants));
    }

    /**
     * 相談担当者名を取得する
     * @param mail 
     */
    public async getConsultantName(mail: string): Promise<string> {
        if(!mail) return '';

        if (!this.consultants) {
            await this.getConsultants();
        }

        for (let item of this.consultants) {
            if (mail === item.consultantMail) return item.consultantName;
        }
        return '';
    }


    /**
     * 相談窓口の相談担当者を更新する
     * @param consultants 
     */
    public async updateConsultants(consultants: Array<MstConsultantModel & {del: boolean}>) {
        await this.http.put(environment.host + environment.api_version + '/mst/consultant', consultants).toPromise();

        // クライアントのキャッシュを更新する
        this.consultants = await this.get<Array<mstInterface.consultant.GetRes>>('/mst/consultant');
    }


    /**
     * システム管理者一覧取得
     */
    public async getSystemAdmins(): Promise<Array<MstSystemAdminModel>> {

        let list = await this.get<Array<mstInterface.systemAdmin.GetRes>>('/mst/systemadmin');
        let res: Array<MstSystemAdminModel> = [];
        list.forEach(item => {
            res.push(
                Object.assign(item, {
                    pass: '',
                    del: false
                })
            )
        });

        return res;
    }

    /**
     * システム管理者を更新する
     * @param systemAdmins 
     */
    public async updateSystemAdmins(systemAdmins: Array<MstSystemAdminModel>) {
        let reqData: Array<MstSystemAdminModel> = [];

        systemAdmins.forEach(item => {

            let newItem = {
                mail: item.mail,
                name: item.name,
                pass: '',
                del: item.del
            }

            if (!item.del) {
                
                // ハッシュ値を取る
                let hash = CryptoJS.SHA256(item.pass).toString();
                newItem.pass = CryptoJS.SHA256(hash + newItem.mail + environment.host).toString();
            }
            reqData.push(newItem);
        })


        await this.put('/mst/systemadmin', reqData);
    }



    /**
     * 相談区分一覧取得
     */
    public async getHarassmentTypes(): Promise<Array<MstHarassmentTypeModel>> {
        if (!this.harassmentTypes) {
            this.harassmentTypes = await this.get<Array<mstInterface.harassmentType.GetRes>>('/mst/harassmentType');
        }

        return JSON.parse(JSON.stringify(this.harassmentTypes));
    }

    /**
     * 相談区分名を取得する
     * @param id 
     */
    public async getHarassmentTypeName(id: string): Promise<string> {
        if(!id) return '';

        if (!this.harassmentTypes) {
            await this.getHarassmentTypes();
        }

        for (let item of this.harassmentTypes) {
            if (id == item.id) return item.name;
        }
        return '';
    }

    /**
     * 相談区分を更新する
     * @param harassmentTypes 
     */
    public async updateHarassmentTypes(harassmentTypes: Array<MstHarassmentTypeModel>) {
        await this.put('/mst/harassmentType', harassmentTypes);

        // クライアントのキャッシュを更新する
        this.harassmentTypes = await this.get<Array<mstInterface.harassmentType.GetRes>>('/mst/harassmentType');
    }


    /**
     * 被害時間帯一覧取得
     */
    public async getInjuryTimes(): Promise<Array<MstInjuryTimeModel>> {
        if (!this.injuryTimes) {
            this.injuryTimes = await this.get<Array<mstInterface.injuryTime.GetRes>>('/mst/injuryTime');
        }

        return JSON.parse(JSON.stringify(this.injuryTimes));
    }


    /**
     * 被害時間帯名を取得する
     * @param id 
     */
    public async getInjuryTimeName(id: string): Promise<string> {
        if(!id) return '';

        if (!this.injuryTimes) {
            await this.getInjuryTimes();
        }

        for (let item of this.injuryTimes) {
            if (id == item.id) return item.name;
        }
        return '';
    }

    /**
     * 被害時間帯を更新する
     * @param injuryTimes 
     */
    public async updateInjuryTimes(injuryTimes: Array<MstInjuryTimeModel>) {
        await this.put('/mst/injuryTime', injuryTimes);

        // クライアントのキャッシュを更新する
        this.injuryTimes = await this.get<Array<mstInterface.injuryTime.GetRes>>('/mst/injuryTime');
    }

    /**
     * お知らせ一覧取得
     */
    public async getNotifications(): Promise<Array<MstNotificationModel>> {
        if (!this.notifications) {
            this.notifications = await this.get<Array<mstInterface.notification.GetRes>>('/mst/notification');
        }

        return JSON.parse(JSON.stringify(this.notifications));
    }

    /**
     * お知らせ一覧を更新する
     * @param notifications 
     */
    public async updateNotifications(notifications: Array<MstNotificationModel>) {
        await this.put('/mst/notification', notifications);

        // クライアントのキャッシュを更新する
        this.notifications = await this.get<Array<mstInterface.notification.GetRes>>('/mst/notification');
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/services/master/master.service.ts